/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
  * @class PageContent
  * @classdesc This Content child class exists to abstract away the genericPage layout from contents of the page type. Objects of this class are created by the PageContentProvider.
  */
define([
	'./Content'
], function (Content) {
	class PageContent extends Content {
		getType() {
			return 'page';
		}
		getChildren() {
			const genericPage = this.layoutModel.items[0];
			if (genericPage.items) {
				return genericPage.items.map(item=>this.getContent(item.id));
			} else {
				return [];
			}
		}
		addContent(content) {
			if(content.containerId === this.layoutModel.id) {
				content.containerId = this.layoutModel.items[0].id;
			}
			return super.addContent(...arguments);
		}
		moveContent(containerId, contentIdList, transactionToken) {
			containerId = this.layoutModel.items[0].id;
			return super.moveContent(containerId, contentIdList, transactionToken);
		}
	}
	return PageContent;
});
